module.exports = __webpack_public_path__ + "img/appearanceCertificate.a5f0ae0d.png";